const on = (eventType: any, listener: any): void => {
  document.addEventListener(eventType, listener);
};
const off = (eventType: any, listener: any): void => {
  document.removeEventListener(eventType, listener);
};
const once = (eventType: any, listener: any): void => {
  const handleEventOnce = (event: any): void => {
    listener(event);
    off(eventType, handleEventOnce);
  };

  on(eventType, handleEventOnce);
};
const trigger = (eventType: any, data: any): void => {
  const event = new CustomEvent(eventType, { detail: data });
  document.dispatchEvent(event);
};
export { on, once, off, trigger };
